import { cardItems } from '@/mocks/homepage';

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900">精选推荐</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">编辑团队精心挑选的擦边内容合集</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((card) => (
            <div
              key={card.title}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2">{card.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}